
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/deliverability",
      function () {
        return require("private-next-pages/native-delivery/deliverability.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/deliverability"])
      });
    }
  